var lt = Object.defineProperty;
var dt = (t, e, r) =>
  e in t
    ? lt(t, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: r,
      })
    : (t[e] = r);
var A = (t, e, r) => (dt(t, typeof e != 'symbol' ? e + '' : e, r), r);
import {
  n as W,
  g as H,
  S as g,
  P as w,
  N as L,
  T as ut,
} from './thumbs.chunk.js';
function j({ swiper: t, extendParams: e, on: r }) {
  e({
    controller: {
      control: void 0,
      inverse: !1,
      by: 'slide',
    },
  }),
    (t.controller = {
      control: void 0,
    });
  function n(l, c) {
    const d = (function () {
      let h, p, f;
      return (S, b) => {
        for (p = -1, h = S.length; h - p > 1; )
          (f = (h + p) >> 1), S[f] <= b ? (p = f) : (h = f);
        return h;
      };
    })();
    (this.x = l), (this.y = c), (this.lastIndex = l.length - 1);
    let u, m;
    return (
      (this.interpolate = function (h) {
        return h
          ? ((m = d(this.x, h)),
            (u = m - 1),
            ((h - this.x[u]) * (this.y[m] - this.y[u])) /
              (this.x[m] - this.x[u]) +
              this.y[u])
          : 0;
      }),
      this
    );
  }
  function o(l) {
    t.controller.spline ||
      (t.controller.spline = t.params.loop
        ? new n(t.slidesGrid, l.slidesGrid)
        : new n(t.snapGrid, l.snapGrid));
  }
  function a(l, c) {
    const d = t.controller.control;
    let u, m;
    const y = t.constructor;
    function h(p) {
      const f = t.rtlTranslate ? -t.translate : t.translate;
      t.params.controller.by === 'slide' &&
        (o(p), (m = -t.controller.spline.interpolate(-f))),
        (!m || t.params.controller.by === 'container') &&
          ((u =
            (p.maxTranslate() - p.minTranslate()) /
            (t.maxTranslate() - t.minTranslate())),
          (m = (f - t.minTranslate()) * u + p.minTranslate())),
        t.params.controller.inverse && (m = p.maxTranslate() - m),
        p.updateProgress(m),
        p.setTranslate(m, t),
        p.updateActiveIndex(),
        p.updateSlidesClasses();
    }
    if (Array.isArray(d))
      for (let p = 0; p < d.length; p += 1)
        d[p] !== c && d[p] instanceof y && h(d[p]);
    else d instanceof y && c !== d && h(d);
  }
  function i(l, c) {
    const d = t.constructor,
      u = t.controller.control;
    let m;
    function y(h) {
      h.setTransition(l, t),
        l !== 0 &&
          (h.transitionStart(),
          h.params.autoHeight &&
            W(() => {
              h.updateAutoHeight();
            }),
          h.$wrapperEl.transitionEnd(() => {
            u &&
              (h.params.loop &&
                t.params.controller.by === 'slide' &&
                h.loopFix(),
              h.transitionEnd());
          }));
    }
    if (Array.isArray(u))
      for (m = 0; m < u.length; m += 1)
        u[m] !== c && u[m] instanceof d && y(u[m]);
    else u instanceof d && c !== u && y(u);
  }
  function s() {
    t.controller.control &&
      t.controller.spline &&
      ((t.controller.spline = void 0), delete t.controller.spline);
  }
  r('beforeInit', () => {
    t.controller.control = t.params.controller.control;
  }),
    r('update', () => {
      s();
    }),
    r('resize', () => {
      s();
    }),
    r('observerUpdate', () => {
      s();
    }),
    r('setTranslate', (l, c, d) => {
      t.controller.control && t.controller.setTranslate(c, d);
    }),
    r('setTransition', (l, c, d) => {
      t.controller.control && t.controller.setTransition(c, d);
    }),
    Object.assign(t.controller, {
      setTranslate: a,
      setTransition: i,
    });
}
function D({ swiper: t, extendParams: e, on: r, emit: n }) {
  let o;
  (t.autoplay = {
    running: !1,
    paused: !1,
  }),
    e({
      autoplay: {
        enabled: !1,
        delay: 3e3,
        waitForTransition: !0,
        disableOnInteraction: !0,
        stopOnLastSlide: !1,
        reverseDirection: !1,
        pauseOnMouseEnter: !1,
      },
    });
  function a() {
    if (!t.size) {
      (t.autoplay.running = !1), (t.autoplay.paused = !1);
      return;
    }
    const p = t.slides.eq(t.activeIndex);
    let f = t.params.autoplay.delay;
    p.attr('data-swiper-autoplay') &&
      (f = p.attr('data-swiper-autoplay') || t.params.autoplay.delay),
      clearTimeout(o),
      (o = W(() => {
        let S;
        t.params.autoplay.reverseDirection
          ? t.params.loop
            ? (t.loopFix(),
              (S = t.slidePrev(t.params.speed, !0, !0)),
              n('autoplay'))
            : t.isBeginning
            ? t.params.autoplay.stopOnLastSlide
              ? s()
              : ((S = t.slideTo(t.slides.length - 1, t.params.speed, !0, !0)),
                n('autoplay'))
            : ((S = t.slidePrev(t.params.speed, !0, !0)), n('autoplay'))
          : t.params.loop
          ? (t.loopFix(),
            (S = t.slideNext(t.params.speed, !0, !0)),
            n('autoplay'))
          : t.isEnd
          ? t.params.autoplay.stopOnLastSlide
            ? s()
            : ((S = t.slideTo(0, t.params.speed, !0, !0)), n('autoplay'))
          : ((S = t.slideNext(t.params.speed, !0, !0)), n('autoplay')),
          ((t.params.cssMode && t.autoplay.running) || S === !1) && a();
      }, f));
  }
  function i() {
    return typeof o < 'u' || t.autoplay.running
      ? !1
      : ((t.autoplay.running = !0), n('autoplayStart'), a(), !0);
  }
  function s() {
    return !t.autoplay.running || typeof o > 'u'
      ? !1
      : (o && (clearTimeout(o), (o = void 0)),
        (t.autoplay.running = !1),
        n('autoplayStop'),
        !0);
  }
  function l(p) {
    t.autoplay.running &&
      (t.autoplay.paused ||
        (o && clearTimeout(o),
        (t.autoplay.paused = !0),
        p === 0 || !t.params.autoplay.waitForTransition
          ? ((t.autoplay.paused = !1), a())
          : ['transitionend', 'webkitTransitionEnd'].forEach((f) => {
              t.$wrapperEl[0].addEventListener(f, d);
            })));
  }
  function c() {
    const p = H();
    p.visibilityState === 'hidden' && t.autoplay.running && l(),
      p.visibilityState === 'visible' &&
        t.autoplay.paused &&
        (a(), (t.autoplay.paused = !1));
  }
  function d(p) {
    !t ||
      t.destroyed ||
      !t.$wrapperEl ||
      (p.target === t.$wrapperEl[0] &&
        (['transitionend', 'webkitTransitionEnd'].forEach((f) => {
          t.$wrapperEl[0].removeEventListener(f, d);
        }),
        (t.autoplay.paused = !1),
        t.autoplay.running ? a() : s()));
  }
  function u() {
    t.params.autoplay.disableOnInteraction ? s() : (n('autoplayPause'), l()),
      ['transitionend', 'webkitTransitionEnd'].forEach((p) => {
        t.$wrapperEl[0].removeEventListener(p, d);
      });
  }
  function m() {
    t.params.autoplay.disableOnInteraction ||
      ((t.autoplay.paused = !1), n('autoplayResume'), a());
  }
  function y() {
    t.params.autoplay.pauseOnMouseEnter &&
      (t.$el.on('mouseenter', u), t.$el.on('mouseleave', m));
  }
  function h() {
    t.$el.off('mouseenter', u), t.$el.off('mouseleave', m);
  }
  r('init', () => {
    t.params.autoplay.enabled &&
      (i(), H().addEventListener('visibilitychange', c), y());
  }),
    r('beforeTransitionStart', (p, f, S) => {
      t.autoplay.running &&
        (S || !t.params.autoplay.disableOnInteraction
          ? t.autoplay.pause(f)
          : s());
    }),
    r('sliderFirstMove', () => {
      t.autoplay.running &&
        (t.params.autoplay.disableOnInteraction ? s() : l());
    }),
    r('touchEnd', () => {
      t.params.cssMode &&
        t.autoplay.paused &&
        !t.params.autoplay.disableOnInteraction &&
        a();
    }),
    r('destroy', () => {
      h(),
        t.autoplay.running && s(),
        H().removeEventListener('visibilitychange', c);
    }),
    Object.assign(t.autoplay, {
      pause: l,
      run: a,
      start: i,
      stop: s,
    });
}
function pt(t) {
  const {
    effect: e,
    swiper: r,
    on: n,
    setTranslate: o,
    setTransition: a,
    overwriteParams: i,
    perspective: s,
    recreateShadows: l,
    getEffectParams: c,
  } = t;
  n('beforeInit', () => {
    if (r.params.effect !== e) return;
    r.classNames.push(`${r.params.containerModifierClass}${e}`),
      s && s() && r.classNames.push(`${r.params.containerModifierClass}3d`);
    const u = i ? i() : {};
    Object.assign(r.params, u), Object.assign(r.originalParams, u);
  }),
    n('setTranslate', () => {
      r.params.effect === e && o();
    }),
    n('setTransition', (u, m) => {
      r.params.effect === e && a(m);
    }),
    n('transitionEnd', () => {
      if (r.params.effect === e && l) {
        if (!c || !c().slideShadows) return;
        r.slides.each((u) => {
          r.$(u)
            .find(
              '.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left'
            )
            .remove();
        }),
          l();
      }
    });
  let d;
  n('virtualUpdate', () => {
    r.params.effect === e &&
      (r.slides.length || (d = !0),
      requestAnimationFrame(() => {
        d && r.slides && r.slides.length && (o(), (d = !1));
      }));
  });
}
function mt(t, e) {
  return t.transformEl
    ? e.find(t.transformEl).css({
        'backface-visibility': 'hidden',
        '-webkit-backface-visibility': 'hidden',
      })
    : e;
}
function ht({ swiper: t, duration: e, transformEl: r, allSlides: n }) {
  const { slides: o, activeIndex: a, $wrapperEl: i } = t;
  if (t.params.virtualTranslate && e !== 0) {
    let s = !1,
      l;
    n ? (l = r ? o.find(r) : o) : (l = r ? o.eq(a).find(r) : o.eq(a)),
      l.transitionEnd(() => {
        if (s || !t || t.destroyed) return;
        (s = !0), (t.animating = !1);
        const c = ['webkitTransitionEnd', 'transitionend'];
        for (let d = 0; d < c.length; d += 1) i.trigger(c[d]);
      });
  }
}
function T({ swiper: t, extendParams: e, on: r }) {
  e({
    fadeEffect: {
      crossFade: !1,
      transformEl: null,
    },
  }),
    pt({
      effect: 'fade',
      swiper: t,
      on: r,
      setTranslate: () => {
        const { slides: a } = t,
          i = t.params.fadeEffect;
        for (let s = 0; s < a.length; s += 1) {
          const l = t.slides.eq(s);
          let d = -l[0].swiperSlideOffset;
          t.params.virtualTranslate || (d -= t.translate);
          let u = 0;
          t.isHorizontal() || ((u = d), (d = 0));
          const m = t.params.fadeEffect.crossFade
            ? Math.max(1 - Math.abs(l[0].progress), 0)
            : 1 + Math.min(Math.max(l[0].progress, -1), 0);
          mt(i, l)
            .css({
              opacity: m,
            })
            .transform(`translate3d(${d}px, ${u}px, 0px)`);
        }
      },
      setTransition: (a) => {
        const { transformEl: i } = t.params.fadeEffect;
        (i ? t.slides.find(i) : t.slides).transition(a),
          ht({
            swiper: t,
            duration: a,
            transformEl: i,
            allSlides: !0,
          });
      },
      overwriteParams: () => ({
        slidesPerView: 1,
        slidesPerGroup: 1,
        watchSlidesProgress: !0,
        spaceBetween: 0,
        virtualTranslate: !t.params.cssMode,
      }),
    });
}
document.addEventListener('click', yt);
function yt(t) {
  const e = t.target.closest('.jc-modal-open');
  if (e) {
    const n = e.dataset.id;
    ft(document.querySelector(n));
  }
  const r = t.target.closest('.jc-modal-close');
  r && (t.preventDefault(), St(r.closest('.jc-modal')));
}
function ft(t) {
  t.classList.add('show'), (document.body.style.overflow = 'hidden');
}
function St(t) {
  t.classList.remove('show'), (document.body.style.overflow = 'auto');
}
const gt = () => {
  const t = document.querySelectorAll('.accordion'),
    e = 'accordion_open';
  function r(o) {
    o.closest('.accordion-wrapper')
      .querySelectorAll('.accordion')
      .forEach((i) => {
        i.classList.remove(e),
          (i.querySelector('.accordion__content-wrapper').style.height = '0');
      });
  }
  t.forEach((o) => {
    const a = o.querySelector('.accordion__header').parentElement,
      i = o.querySelector('.accordion__content-wrapper'),
      s = o.querySelector('.accordion__content'),
      l = () => {
        o.classList.add(e), (i.style.height = `${s.offsetHeight}px`);
      };
    o.hasAttribute('data-accordion-open') && l(),
      a.addEventListener('click', () => {
        const c = !o.classList.contains(e);
        r(o), c && l();
      });
  }),
    window.addEventListener('scroll', n),
    window.addEventListener('resize', n);
  function n() {
    document.querySelectorAll('.accordion__content-wrapper').forEach((o) => {
      o.style.height != '0px' &&
        (o.style.height =
          o.querySelector('.accordion__content').scrollHeight + 'px');
    });
  }
};
gt();
class vt extends HTMLElement {
  constructor() {
    super(),
      (this.elements = {
        setValue: this.querySelector('[data-option-dropdown-value]'),
        getValue: this.querySelector('input:checked'),
        selectBox: this.querySelector('[data-option-dropdown-block]'),
        valueBox: this.querySelector('[data-option-dropdown-items]'),
      }),
      this.init();
  }
  init() {
    (this.elements.setValue.innerHTML = this.elements.getValue.value),
      this.elements.valueBox.querySelectorAll('input').length > 1
        ? this.elements.selectBox.addEventListener('click', () => {
            document
              .querySelectorAll('[data-option-dropdown-block].open')
              .forEach((e) => {
                e != this.elements.selectBox &&
                  (e.classList.toggle('open'),
                  e.querySelector('svg').classList.toggle('jc-rotate-180'),
                  e.nextElementSibling.classList.toggle('jc-hidden'));
              }),
              this.elements.selectBox.classList.toggle('open'),
              this.elements.selectBox
                .querySelector('svg')
                .classList.toggle('jc-rotate-180'),
              this.elements.valueBox.classList.toggle('jc-hidden');
          })
        : this.elements.selectBox
            .querySelector('svg')
            .classList.add('jc-hidden'),
      document.addEventListener('click', (e) => {
        e.target.closest('jolly-dropdown') ||
          document
            .querySelectorAll('[data-option-dropdown-block].open')
            .forEach((r) => {
              r.classList.toggle('open'),
                r.querySelector('svg').classList.toggle('jc-rotate-180'),
                r.nextElementSibling.classList.toggle('jc-hidden');
            });
      });
  }
}
customElements.define('jolly-dropdown', vt);
let qt = class extends HTMLElement {
  constructor() {
    super(),
      (this.elements = {
        variants: this.querySelectorAll('.js-variants-update'),
        variantsJSON: this.querySelector('[data-product-variants-json]'),
        sectionId: 'ajax-jolly-main-product-info',
      }),
      this.init();
  }
  init() {
    this.elements.variants.forEach((s) => {
      s.addEventListener('click', async () => {
        const l = JSON.parse(this.elements.variantsJSON.textContent),
          c = this.querySelectorAll('.js-variants-update:checked');
        let d = [];
        c.forEach((p) => {
          d.push(p.value);
        });
        const u = l.filter((p) => p.options.join(',') === d.join(','))[0],
          m = this.dataset.productHandle,
          y = u.id,
          h = this.elements.sectionId;
        await this.updateProductInfo(m, y, h);
      });
    });
    const e = JSON.parse(this.elements.variantsJSON.textContent),
      r = this.querySelectorAll('.js-variants-update:checked');
    let n = [];
    r.forEach((s) => {
      n.push(s.value);
    });
    const a = e.filter((s) => s.options.join(',') === n.join(','))[0].id,
      i = document.querySelector('jolly-add-to-pack');
    i && (i.dataset.variantId = a);
  }
  async updateProductInfo(e, r, n) {
    var o, a, i, s, l, c;
    try {
      const d = await fetch(`/products/${e}?variant=${r}&section_id=${n}`);
      if (!d.ok) throw new Error(`Failed to fetch product: ${d.statusText}`);
      const u = await d.text(),
        y = new DOMParser().parseFromString(u, 'text/html'),
        h = document.querySelector('#jolly-variants'),
        p =
          (o = y.querySelector('#jolly-variants')) == null
            ? void 0
            : o.innerHTML,
        f = document.querySelector('#js-main-product-price'),
        S = document.querySelector(
          '#js-modal-product-price [data-product-price]'
        ),
        b = document.querySelector(
          '#js-modal-product-price [data-product-compare-price]'
        ),
        F =
          (a = y.querySelector('#js-main-product-price')) == null
            ? void 0
            : a.innerHTML,
        st =
          (i = y.querySelector('[data-product-price]')) == null
            ? void 0
            : i.innerHTML,
        it =
          (s = y.querySelector('[data-product-compare-price]')) == null
            ? void 0
            : s.innerHTML,
        V = document.querySelector('#js-main-product-sticky-atc-price'),
        N = document.querySelector('#js-main-product-sticky-atc'),
        J = document.querySelector('#js-main-product-sticky-atc-title'),
        ct =
          (l = y.querySelector('#js-main-product-sticky-atc-title')) == null
            ? void 0
            : l.innerHTML,
        Q = document.querySelector('#buy-button-block'),
        U =
          (c = y.querySelector('#buy-button-block')) == null
            ? void 0
            : c.innerHTML,
        R = document.querySelector('jolly-add-to-pack');
      R && (R.dataset.variantId = r);
      const M = document.querySelector('jolly-pack-progress[product]');
      M &&
        (localStorage.removeItem('packStorage'),
        M.setAttribute('product', r),
        M.setAttribute('qnt', '1')),
        f && (f.innerHTML = F),
        S && (S.innerHTML = st),
        b && (b.innerHTML = it),
        h && (h.innerHTML = p),
        Q && (Q.innerHTML = U),
        V && (V.innerHTML = F),
        N && (N.innerHTML = U),
        J && (J.innerHTML = ct);

      document.dispatchEvent(new CustomEvent('globo.preorder.variant.change'));
    } catch (d) {
      console.error(`An error occurred: ${d}`);
    }
  }
};
customElements.define('variant-picker', qt);
const x = document.querySelectorAll('.jc-swiper-client'),
  bt = document.querySelectorAll('.jc-swiper-client-review');
for (let t = 0; t < x.length; t++) {
  var z = new g('#' + x[t].id, {
      modules: [j, w],
      spaceBetween: 16,
      slidesPerView: 1.15,
      breakpoints: {
        768: {
          spaceBetween: 24,
          slidesPerView: 1.45,
        },
      },
      watchSlidesProgress: !0,
      slideToClickedSlide: !0,
      pagination: {
        el: x[t].querySelector('.jc-swiper-client-pagination'),
        clickable: !0,
      },
    }),
    G = new g('#' + bt[t].id, {
      modules: [j, T],
      slidesPerView: 1.15,
      effect: 'fade',
      speed: 500,
      spaceBetween: 10,
    });
  (G.controller.control = z), (z.controller.control = G);
}
const _t = document.querySelector('.jc-menu-toggle'),
  E = document.querySelector('.jc-menu');
document.querySelectorAll('.jc-mobile-menu');
document.querySelector('.jolly-header--megamenu');
document.querySelectorAll('.jc-primary-menu--link');
document.querySelectorAll('.jolly-header--submenu');
document.getElementById('header_menu_shadow');
_t.addEventListener('click', function () {
  let t = document.querySelector('.jolly-header');
  E.classList.contains('active')
    ? (E.classList.remove('active'),
      (t.style.position = ''),
      document.body.classList.remove('jc-overflow-hidden'))
    : (E.classList.add('active'),
      document.body.classList.add('jc-overflow-hidden')),
    this.classList.toggle('active'),
    O(),
    P();
});
window.addEventListener('DOMContentLoaded', O);
window.addEventListener('scroll', () => {
  if (window.innerWidth <= 1280) O(), P();
  else return !1;
});
P();
window.addEventListener('resize', () => {
  if (window.innerWidth <= 1280)
    P(),
      E.classList.contains('active') &&
        document.body.classList.add('jc-overflow-hidden');
  else
    return (
      document
        .querySelector('.jolly-header')
        .style.setProperty('--jolly-section-color', '#0a0a0a'),
      E.classList.contains('active') &&
        document.body.classList.remove('jc-overflow-hidden'),
      !1
    );
});
function O() {
  let t = document.querySelector('.jolly-header');
  if (t) {
    let e = t.getBoundingClientRect().top,
      r = t.offsetHeight + e;
    E.style.top = r + 'px';
  }
}
function P() {
  let t = document.querySelector('.jolly-header');
  t &&
    (t.getBoundingClientRect().top === 0
      ? (t.classList.contains('js-header-bg') &&
          t.style.setProperty('--header_bg_mobile', t.dataset.bgColor),
        t.classList.contains('js-header-color') &&
          t.style.setProperty('--jolly-section-color', '#0a0a0a'))
      : (t.classList.contains('js-header-bg') &&
          t.style.setProperty('--header_bg_mobile', 'transparent'),
        t.classList.contains('js-header-color') &&
          t.style.setProperty('--jolly-section-color', 'white')));
}
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.jc-mobile-menu a').forEach((e) => {
    e.addEventListener('click', function (r) {
      const n = r.target.nextElementSibling;
      if (
        (e
          .closest('ul')
          .querySelectorAll('a')
          .forEach((i) => {
            e != i && i.classList.remove('active');
          }),
        e.classList.contains('active')
          ? e.classList.remove('active')
          : e.classList.add('active'),
        !n || n.tagName !== 'UL')
      )
        return !0;
      r.preventDefault();
      let a = e.closest('ul.js-submenu');
      if (a) {
        a.style.maxHeight = '100%';
        let i = a.querySelectorAll('ul');
        if (!i) return;
        i.forEach((s) => {
          n != s && (s.style.maxHeight = '0px');
        });
      }
      n.style.maxHeight != '0px'
        ? (n.style.maxHeight = '0px')
        : (n.style.maxHeight = n.scrollHeight + 'px');
    });
  });
});
class K extends HTMLElement {
  constructor() {
    var e, r;
    super(),
      (this.input = this.querySelector('input')),
      (this.changeEvent = new Event('change', {
        bubbles: !0,
      })),
      this.input &&
        this.input.addEventListener('change', this.onInputChange.bind(this)),
      this.querySelectorAll('button').forEach((n) =>
        n.addEventListener('click', this.onButtonClick.bind(this))
      ),
      this.input && this.checkInputValue(this.input.value),
      (e = this.closest('form')) != null &&
        e.querySelector('[data-product-price]') &&
        (this.price = this.closest('form').querySelector(
          '[data-product-price]'
        )),
      (r = this.closest('form')) != null &&
        r.querySelector('[data-product-compare-price]') &&
        (this.comparePrice = this.closest('form').querySelector(
          '[data-product-compare-price]'
        ));
  }
  checkInputValue(e) {
    const r = this.querySelector(".quantity__button[name='minus']");
    e == 1 && r.classList.add('disabled');
  }
  onInputChange(e) {
    this.validateQtyRules();
  }
  onButtonClick(e) {
    e.preventDefault();
    const r = this.input.value;
    if (
      (e.target.name === 'plus'
        ? this.closest(this.tagName)
            .querySelectorAll('.jc-quantity__input')
            .forEach((n) => {
              n.stepUp(),
                document
                  .querySelectorAll(this.tagName + ' .jc-quantity__input')
                  .forEach((o) => (o.value = n.value));
            })
        : this.closest(this.tagName)
            .querySelectorAll('.jc-quantity__input')
            .forEach((n) => {
              n.stepDown(),
                document
                  .querySelectorAll(this.tagName + ' .jc-quantity__input')
                  .forEach((o) => (o.value = n.value));
            }),
      r !== this.input.value)
    ) {
      this.input.dispatchEvent(this.changeEvent);
      const n = document.querySelector('jolly-pack-progress[product]');
      n && n.setAttribute('qnt', this.input.value);
    }
  }
  validateQtyRules() {
    document.querySelectorAll('jolly-quantity-selector').forEach((r) => {
      const n = parseInt(r.querySelector('input').value);
      if (r.querySelector('input').min) {
        const o = parseInt(r.querySelector('input').min);
        r.querySelector(".quantity__button[name='minus']").classList.toggle(
          'disabled',
          n <= o
        );
      }
      if (r.querySelector('input').max) {
        const o = parseInt(r.querySelector('input').max);
        r.querySelector(".quantity__button[name='plus']").classList.toggle(
          'disabled',
          n >= o
        );
      }
      (r.closest('form').querySelector('[data-product-price]').innerText =
        parseFloat(
          r.closest('form').querySelector('[data-product-price]').dataset
            .productPrice
        ) *
          n +
        '€'),
        r.closest('form').querySelector('[data-product-compare-price]') &&
          (r
            .closest('form')
            .querySelector('[data-product-compare-price]').innerText =
            parseFloat(
              r.closest('form').querySelector('[data-product-compare-price]')
                .dataset.productComparePrice
            ) *
              n +
            '€');
    });
  }
}
customElements.define('jolly-quantity-selector', K);
localStorage.removeItem('packStorage');
localStorage.removeItem('cartStorage');
const v = () => {
    if (localStorage.getItem('packStorage') !== null)
      return JSON.parse(localStorage.getItem('packStorage'));
    {
      let t = {
        _total_original_price: 0,
        _total_discounted_price: 0,
        _total_discount_percent: 0,
        _total_qnt: 0,
      };
      return localStorage.setItem('packStorage', JSON.stringify(t)), t;
    }
  },
  q = JSON.parse(
    document.querySelector('discount-object').innerHTML.replaceAll("'", '"')
  ),
  _ = async () => {
    let t = {
        _total_original_price: 0,
        _total_discounted_price: 0,
        _total_discount_percent: 0,
        _total_qnt: 0,
      },
      e = 0,
      r = 0,
      n = 0;
    const a = await (await fetch('/cart.js')).json();
    for (const c in a.items)
      a.items[c].properties.hasOwnProperty('_pack') &&
        a.items[c].properties._pack == 'true' &&
        (t[`${a.items[c].id}`] === void 0 && (t[`${a.items[c].id}`] = {}),
        (t[`${a.items[c].id}`]._variant_id = a.items[c].id),
        (t[`${a.items[c].id}`]._product_handle = a.items[c].url
          .replaceAll('?', '')
          .replaceAll('/products/', '')
          .replaceAll(/variant=.*/g, '')),
        (t[`${a.items[c].id}`]._variant_qnt = a.items[c].quantity),
        (t[`${a.items[c].id}`]._variant_original_price =
          a.items[c].original_price / 100),
        (t[`${a.items[c].id}`]._variant_original_pack_price =
          a.items[c].final_line_price / 100),
        (e += parseFloat(a.items[c].original_line_price / 100)),
        (r += parseFloat(a.items[c].final_line_price / 100)),
        (n += parseInt(a.items[c].quantity)));
    (t._total_original_price = parseFloat(e).toFixed(2)),
      (t._total_discounted_price = parseFloat(r).toFixed(2)),
      (t._total_discount_percent = I(n)),
      (t._total_qnt = parseInt(n)),
      localStorage.setItem('cartStorage', JSON.stringify(t)),
      document.querySelectorAll('jolly-pack-details').forEach((c) => {
        c.dispatchPackSummaryUpdate();
      }),
      document.querySelectorAll('[total-cart-pack-qnt]').forEach((c) => {
        c.innerHTML = t._total_qnt;
      });
    const s = document.querySelector('jolly-pack-progress[pack-page]'),
      l = document.querySelector('jolly-pack-progress[product]');
    return (
      s && s.setAttribute('qnt', parseInt(n)),
      l && l.setAttribute('qnt', l.getAttribute('qnt')),
      t
    );
  };
document.addEventListener('cart:update', async () => {
  await _(),
    document.querySelectorAll('jolly-pack-quantity-selector').forEach((e) => {
      e.validateQtyRules();
    });
  const t = document.querySelector('cart-drawer').dataset.sectionId;
  await fetch(window.Shopify.routes.root + '?sections=' + t)
    .then((e) => e.json())
    .then((e) => {
      let r = e[t];
      const o = new DOMParser().parseFromString(r, 'text/html');
      document.querySelector('.drawer__inner').innerHTML.trim() !=
        o.querySelector('.drawer__inner').innerHTML.trim() &&
        (document.querySelector('.drawer__inner').innerHTML =
          o.querySelector('.drawer__inner').innerHTML),
        document.querySelectorAll('jolly-pack-items').forEach((a) => {
          o.querySelector('jolly-pack-items')
            ? a.innerHTML.trim() !=
                o.querySelector('jolly-pack-items').innerHTML.trim() &&
              (a.innerHTML = o.querySelector('jolly-pack-items').innerHTML)
            : (a.innerHTML = '');
        }),
        document.dispatchEvent(new CustomEvent('jc-cart:reload'));
    })
    .then(() => {
      document.querySelectorAll('jolly-pack-details').forEach((r) => {
        r.dispatchPackSummaryUpdate();
      });
    });
});
_();
function Z() {
  let t = 0;
  const r = document.querySelector('header').offsetHeight,
    n = document.querySelector('.js-sticky--jolly-pack-details');
  t !== r && (n && (n.style.top = r + 'px'), (t = r));
}
Z();
window.addEventListener('resize', Z);
class kt extends HTMLElement {
  constructor() {
    super(), this.init();
  }
  init() {
    (this.component = {
      addToPackButton: this.querySelectorAll('jolly-show-modal'),
      productId: this.getAttribute('jolly-card-id'),
      card: this.closest('jolly-pack-card'),
    }),
      this.component.addToPackButton &&
        this.component.addToPackButton.forEach((e) => {
          e.addEventListener('click', async () => {
            localStorage.removeItem('packStorage'),
              await this.showModal(this.component.productId);
            let r = document.querySelector(
              'jolly-pack-buttons jolly-add-to-pack'
            );
            r && r.addItemToPack(r);
          });
        });
  }
  async showModal(e) {
    const r = await this.getSectionHTML('jolly-pack', e),
      o = new DOMParser().parseFromString(r, 'text/html'),
      a = document.createElement('dialog', {
        is: 'jolly-pack-modal',
      });
    if (
      (a.insertAdjacentHTML(
        'afterbegin',
        o.querySelector('jolly-modal').innerHTML
      ),
      navigator.userAgent.indexOf('Safari') > -1)
    ) {
      const s = a.querySelector('jolly-modal-close');
      s &&
        s.addEventListener('click', () => {
          a && a.close(), setTimeout(() => a.remove(), 700);
        }),
        a.addEventListener('click', (l) => {
          var c = a.getBoundingClientRect(),
            d =
              c.top <= l.clientY &&
              l.clientY <= c.top + c.height &&
              c.left <= l.clientX &&
              l.clientX <= c.left + c.width;
          d || (a.close(), setTimeout(() => a.remove(), 700));
        });
    }
    this.component.card.appendChild(a), a.showModal();
  }
  async getSectionHTML(e, r) {
    return new Promise(function (n, o) {
      const a = 'id:' + r,
        i = r ? '&q=' + a : '&type=product',
        s = '/search/?sections=' + e + i;
      fetch(s).then(function (l) {
        l.json().then(function (c) {
          var d = Object.keys(c);
          return d.length > 0 ? n(c[d[0]]) : o();
        });
      });
    });
  }
}
class Et extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    document.querySelectorAll('jolly-pack-items').forEach((r) => {});
  }
  async dispatchPackSummaryUpdate() {
    let e = JSON.parse(localStorage.getItem('cartStorage')) || (await _()),
      r = parseFloat(e._total_original_price),
      n = parseFloat(e._total_discount_percent);
    document.querySelectorAll('[data-pack-total-qnt]').forEach((o) => {
      o.innerHTML = parseInt(e._total_qnt);
    }),
      document
        .querySelectorAll('jolly-pack-summary [data-pack-total-price]')
        .forEach((o) => {
          n == 0 ? (o.innerHTML = '') : (o.innerHTML = Math.round(r) + '€');
        }),
      document
        .querySelectorAll('jolly-pack-summary [data-pack-total-discount]')
        .forEach((o) => {
          o.innerHTML = '-' + Math.round(r - (r * (100 - n)) / 100) + '€';
        }),
      document
        .querySelectorAll(
          'jolly-pack-summary [data-pack-total-discount-percentage]'
        )
        .forEach((o) => {
          o.innerHTML = parseInt(e._total_discount_percent) + '%';
        }),
      document
        .querySelectorAll('[data-pack-total-discount-price]')
        .forEach((o) => {
          o.innerHTML = Math.round((r * (100 - n)) / 100) + '€';
        });
  }
}
class tt extends HTMLElement {
  constructor() {
    super();
  }
  async connectedCallback() {
    let e;
    if (this.hasAttribute('product')) {
      const o = this.getAttribute('product');
      let a = JSON.parse(localStorage.getItem('cartStorage')) || (await _());
      if (((e = v()), !Object.keys(e).includes(o))) {
        let i = document.querySelector('jolly-pack-buttons jolly-add-to-pack');
        i && (await i.addItemToPack(i)), (e = v());
      }
      e._total_qnt =
        parseInt(a._total_qnt) +
        parseInt(e[this.getAttribute('product')]._variant_qnt);
    } else if (this.hasAttribute('pack-page') || this.hasAttribute('cart'))
      e = {
        _total_qnt: this.getAttribute('qnt'),
      };
    else {
      console.error('No data specified');
      return;
    }
    let r = '12px';
    const n = parseInt(Object.keys(q)[Object.keys(q).length - 1]) + 2;
    for (const o in q)
      if (parseInt(o) != 0) {
        const a = document.createElement('jolly-pack-progress-step'),
          i = document.querySelector('#jolly-pack-progress-step').innerHTML;
        (a.dataset.progressStep = o), (a.innerHTML = i);
        let s = this.querySelector('jolly-pack-progress-bar').appendChild(a);
        e._total_qnt >= parseInt(o)
          ? s.querySelector('div').classList.add('active')
          : s.querySelector('div').classList.remove('active'),
          (s.querySelector('div').style.left = `calc(${
            (parseFloat(o) * 100) / n
          }% - ${r})`);
      }
    this.updateProgress();
  }
  attributeChangedCallback(e, r, n) {
    r !== null && this.updateProgress();
  }
  async updateProgress() {
    let e;
    if (this.hasAttribute('product')) {
      const m = this.getAttribute('product');
      let y = JSON.parse(localStorage.getItem('cartStorage')) || (await _());
      if (((e = v()), !Object.keys(e).includes(m))) {
        let h = document.querySelector('jolly-pack-buttons jolly-add-to-pack');
        h && (await h.addItemToPack(h)), (e = v());
      }
      e._total_qnt =
        parseInt(y._total_qnt) +
        parseInt(e[this.getAttribute('product')]._variant_qnt || 1);
    } else if (this.hasAttribute('pack-page') || this.hasAttribute('cart'))
      e = {
        _total_qnt: this.getAttribute('qnt'),
      };
    else {
      console.error('No data specified');
      return;
    }
    let r = '20px';
    const n = this.querySelector('jolly-pack-progress-info'),
      o = parseInt(Object.keys(q)[Object.keys(q).length - 1]) + 2;
    for (const m in q) {
      const y = this.querySelector(
        `jolly-pack-progress-step[data-progress-step='${m}']`
      );
      if (e._total_qnt == 0) {
        n.firstElementChild.classList.add('!jc-hidden'), (n.style.width = r);
        break;
      } else {
        n.firstElementChild.classList.remove('!jc-hidden'),
          (n.style.width =
            Math.min(parseFloat((e._total_qnt / o) * 100), 100) + '%'),
          (n.querySelector('[data-qnt]').innerHTML = `x${e._total_qnt}`);
        for (let h = n.firstElementChild.classList.length - 1; h >= 0; h--) {
          const p = n.firstElementChild.classList[h];
          p.startsWith('discount-step-') &&
            n.firstElementChild.classList.remove(p);
        }
        n.firstElementChild.classList.add(`discount-step-${I(e._total_qnt)}`);
      }
      parseInt(m) != 0 &&
        (e._total_qnt >= parseInt(m)
          ? y == null || y.querySelector('div').classList.add('active')
          : y == null || y.querySelector('div').classList.remove('active'));
    }
    const a = this.querySelector('[data-next-step]'),
      i = this.querySelector('[data-future-discount]'),
      s = this.getAttribute('product'),
      l = this.querySelector('[data-money-save]'),
      c = this.querySelector('jolly-success-message'),
      d = Object.assign({}, q);
    d[99999] = d[Object.keys(d)[Object.keys(d).length - 1]];
    const u = Object.keys(d);
    for (let m = 0; m < u.length - 1; m++)
      parseInt(u[m]) <= e._total_qnt &&
        e._total_qnt < parseInt(u[m + 1]) &&
        (a && (a.innerHTML = parseInt(u[m + 1]) - e._total_qnt),
        i && (i.innerHTML = d[u[m + 1]]),
        l &&
          (l.innerHTML = Math.round(
            (parseInt(u[m + 1]) *
              parseFloat(e[s]._variant_original_price) *
              parseFloat(d[u[m + 1]])) /
              100
          )),
        parseInt(u[m + 1]) == 99999
          ? c && c.classList.add('done')
          : c && c.classList.remove('done'));
  }
}
A(tt, 'observedAttributes', ['qnt']);
class Lt extends HTMLDialogElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.addEventListener('click', (r) => {
      var n = this.getBoundingClientRect(),
        o =
          n.top <= r.clientY &&
          r.clientY <= n.top + n.height &&
          n.left <= r.clientX &&
          r.clientX <= n.left + n.width;
      o || (this.close(), setTimeout(() => this.remove(), 700));
    }),
      this.addEventListener('touchend', (r) => {
        var n = this.getBoundingClientRect(),
          o =
            n.top <= r.clientY &&
            r.clientY <= n.top + n.height &&
            n.left <= r.clientX &&
            r.clientX <= n.left + n.width;
        o || (this.close(), setTimeout(() => this.remove(), 700));
      });
    const e = this.querySelector('jolly-modal-close');
    e && e.addEventListener('click', () => this.closeWithDelay()),
      e && e.addEventListener('touchend', () => this.closeWithDelay());
  }
  closeWithDelay() {
    this.close(), setTimeout(() => this.remove(), 700);
  }
}
class jt extends K {
  constructor() {
    super();
  }
  connectedCallback() {
    const e = parseInt(this.querySelector('input').value);
    this.setPriceValues(e);
  }
  onButtonClick(e) {
    e.preventDefault();
    const r = this.input.value;
    e.target.name === 'plus'
      ? this.closest(this.tagName)
          .querySelectorAll('.jc-quantity__input')
          .forEach((n) => {
            n.stepUp(),
              document
                .querySelectorAll(this.tagName + ' .jc-quantity__input')
                .forEach((a) => {
                  a.value = n.value;
                });
            const o = n
              .closest('jolly-pack-buttons')
              .querySelector('jolly-add-to-pack');
            o && o.addItemToPack(o), o && o.calculateTotalQntPrice();
          })
      : e.target.name === 'minus'
      ? this.closest(this.tagName)
          .querySelectorAll('.jc-quantity__input')
          .forEach((n) => {
            n.stepDown(),
              document
                .querySelectorAll(this.tagName + ' .jc-quantity__input')
                .forEach((a) => (a.value = n.value));
            const o = n
              .closest('jolly-pack-buttons')
              .querySelector('jolly-add-to-pack');
            o && o.removeFromPack(o), o && o.calculateTotalQntPrice();
          })
      : console.error('Button not found'),
      r !== this.input.value && this.input.dispatchEvent(this.changeEvent);
  }
  validateQtyRules() {
    super.validateQtyRules(),
      document.querySelectorAll(this.tagName).forEach((r) => {
        const n = parseInt(r.querySelector('input').value);
        if (r.querySelector('input').min) {
          const o = parseInt(r.querySelector('input').min);
          r.querySelector(".quantity__button[name='minus']").classList.toggle(
            'disabled',
            n <= o
          );
        }
        if (r.querySelector('input').max) {
          const o = parseInt(r.querySelector('input').max);
          r.querySelector(".quantity__button[name='plus']").classList.toggle(
            'disabled',
            n >= o
          );
        }
        this.setPriceValues(n);
      });
  }
  async setPriceValues(e) {
    this.components = {
      addToPackButton: document.querySelectorAll(
        'jolly-pack-buttons jolly-add-to-pack'
      ),
      originalPackPrice: document.querySelectorAll(
        'jolly-pack-buttons [data-pack-original-price]'
      ),
      discountPackPrice: document.querySelectorAll(
        'jolly-pack-buttons [data-pack-discounted-price]'
      ),
    };
    let r = v(),
      n = JSON.parse(localStorage.getItem('cartStorage')) || (await _()),
      o = I(parseInt(r._total_qnt) + parseInt(n._total_qnt)),
      a =
        parseFloat(this.components.addToPackButton[0].dataset.variantPrice) * e,
      i = a * ((100 - o) / 100);
    this.components.originalPackPrice[0] &&
      (a != i
        ? (this.components.originalPackPrice.forEach((s) => {
            s.innerText = Math.round(a) + '€';
          }),
          this.components.originalPackPrice.forEach((s) => {
            s.classList.remove('jc-hidden');
          }))
        : this.components.originalPackPrice.forEach((s) => {
            s.classList.add('jc-hidden');
          }),
      this.components.addToPackButton.forEach((s) => {
        s.dataset.originalVariantPackPrice = Math.round(a);
      })),
      this.components.discountPackPrice[0] &&
        this.components.discountPackPrice.forEach((s) => {
          s.innerText = Math.round(i) + '€';
        }),
      this.components.addToPackButton.forEach((s) => {
        s.dataset.originalVariantPackQnt = 1;
      });
  }
}
class wt extends HTMLElement {
  constructor() {
    super(), this.addEventListener('click', () => this.dispatchCloseEvent());
  }
  async addItemToPack(e) {
    let r = v();
    r[`${e.dataset.variantId}`] === void 0
      ? parseInt(e.dataset.originalVariantPackQnt) <=
        parseInt(e.dataset.variantMaxQnt)
        ? (r[`${e.dataset.variantId}`] = {
            _variant_id: e.dataset.variantId,
            _product_handle: e.dataset.productHandle,
            _variant_qnt: parseInt(e.dataset.originalVariantPackQnt),
            _variant_max_qnt: parseInt(e.dataset.variantMaxQnt),
            _variant_original_price: parseFloat(e.dataset.variantPrice),
            _variant_original_pack_price:
              parseFloat(e.dataset.variantPrice) *
              parseInt(e.dataset.originalVariantPackQnt),
          })
        : console.error("Can't add. Stock too low")
      : parseInt(e.dataset.originalVariantPackQnt) +
          parseInt(r[`${e.dataset.variantId}`]._variant_qnt) <=
        parseInt(e.dataset.variantMaxQnt)
      ? ((r[`${e.dataset.variantId}`]._variant_qnt =
          parseInt(r[`${e.dataset.variantId}`]._variant_qnt) +
          parseInt(e.dataset.originalVariantPackQnt)),
        (r[`${e.dataset.variantId}`]._variant_original_pack_price =
          parseFloat(r[`${e.dataset.variantId}`]._variant_original_price) *
          parseInt(r[`${e.dataset.variantId}`]._variant_qnt)))
      : console.error("Can't add. Stock too low"),
      localStorage.setItem('packStorage', JSON.stringify(r)),
      this.calculateTotalQntPrice(),
      (r = v()),
      this.dispatchAddPackSmallCart(r._total_qnt);
  }
  async removeFromPack(e) {
    let r = v();
    parseInt(r[`${e.dataset.variantId}`]._variant_qnt) -
      parseInt(e.dataset.originalVariantPackQnt) >=
      1 &&
      ((r[`${e.dataset.variantId}`]._variant_qnt =
        parseInt(r[`${e.dataset.variantId}`]._variant_qnt) -
        parseInt(e.dataset.originalVariantPackQnt)),
      (r[`${e.dataset.variantId}`]._variant_original_pack_price =
        parseFloat(r[`${e.dataset.variantId}`]._variant_original_price) *
        parseInt(r[`${e.dataset.variantId}`]._variant_qnt))),
      localStorage.setItem('packStorage', JSON.stringify(r)),
      await this.calculateTotalQntPrice(),
      (r = v()),
      this.dispatchAddPackSmallCart(r._total_qnt);
  }
  async calculateTotalQntPrice() {
    var i;
    let e = v(),
      r = JSON.parse(localStorage.getItem('cartStorage')) || (await _()),
      n = 0,
      o = 0,
      a = 0;
    for (const [s, l] of Object.entries(e))
      (i = e[s]) != null &&
        i.hasOwnProperty('_variant_id') &&
        ((n += parseFloat(e[s]._variant_original_pack_price)),
        (o +=
          parseFloat(e[s]._variant_original_pack_price) *
          ((100 - parseFloat(e._total_discount_percent)) / 100)),
        (a += parseInt(e[s]._variant_qnt)));
    (e._total_original_price = parseFloat(n).toFixed(2)),
      (e._total_discounted_price = parseFloat(o).toFixed(2)),
      (e._total_discount_percent = I(a + parseInt(r._total_qnt))),
      (e._total_qnt = parseInt(a)),
      localStorage.setItem('packStorage', JSON.stringify(e));
  }
  dispatchCloseEvent() {
    const e = this.closest('dialog');
    navigator.userAgent.indexOf('Safari') > -1
      ? (e && e.close(), setTimeout(() => e.remove(), 700))
      : e && e.closeWithDelay();
  }
  dispatchAddPackSmallCart(e) {
    document.querySelectorAll('jolly-pack-details').forEach((a) => {
      a.connectedCallback(), a.dispatchPackSummaryUpdate();
    }),
      document.querySelectorAll('jolly-pack-progress[product]').forEach((a) => {
        a && a.setAttribute('qnt', e);
      }),
      document.querySelectorAll('jolly-pack-quantity-selector').forEach((a) => {
        a && a.setPriceValues(e);
      });
  }
}
class Tt extends HTMLElement {
  constructor() {
    super(), this.addEventListener('click', () => this.addPackToCart());
  }
  addPackToCart() {
    let e = v(),
      r = {
        items: [],
      };
    const n = document.querySelector('cart-drawer').dataset.sectionId;
    for (const o in e)
      if (e[o].hasOwnProperty('_variant_id')) {
        let a = {
          id: e[o]._variant_id,
          quantity: e[o]._variant_qnt,
          properties: {
            _pack: !0,
          },
        };
        r.items.push(a);
      }
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(r),
    })
      .then(
        (o) => (
          fetch(
            window.Shopify.routes.root + 'search/?sections=cart-icon-bubble'
          )
            .then((a) => a.json())
            .then((a) => {
              const s = new DOMParser().parseFromString(
                  a['cart-icon-bubble'],
                  'text/html'
                ),
                l = document.querySelector('.cart-count-bubble');
              l.innerHTML = s.querySelector('.cart-count-bubble').innerHTML;
            }),
          fetch(window.Shopify.routes.root + '?sections=' + n)
            .then((a) => a.json())
            .then((a) => {
              let i = a[n];
              const l = new DOMParser().parseFromString(i, 'text/html');
              (document.querySelector('.drawer__inner').innerHTML =
                l.querySelector('.drawer__inner').innerHTML),
                document
                  .querySelector('cart-drawer')
                  .classList.remove('is-empty'),
                document.querySelector('cart-drawer').classList.add('active'),
                document.dispatchEvent(new CustomEvent('jc-cart:reload')),
                document.dispatchEvent(new CustomEvent('cart:update'));
            }),
          o.json()
        )
      )
      .catch((o) => console.error('Error adding to cart:', o));
  }
}
class Pt extends HTMLElement {
  constructor() {
    super(), this.init();
  }
  init() {
    this.loadFilters().then(() => {
      this.updateFilters().then(() => {
        this.querySelectorAll(`${this.tagName} label`).forEach((e) => {
          e.addEventListener('click', (r) => {
            document.querySelector('.js-loader').classList.remove('jc-hidden'),
              this.updateListProducts(r);
          });
        });
      });
    });
  }
  async loadFilters() {
    try {
      let e = await fetch(
        window.Shopify.routes.root + 'collections/' + this.dataset.collection
      );
      if (!e.ok) throw new Error(`Fetch failed with status: ${e.status}`);
      let r = await e.text();
      const n = new DOMParser(),
        o = n.parseFromString(r, 'text/html'),
        a = document.createElement('dialog');
      a.setAttribute('filter-popup', ''),
        a.addEventListener('click', (s) => {
          var l = a.getBoundingClientRect(),
            c =
              l.top <= s.clientY &&
              s.clientY <= l.top + l.height &&
              l.left <= s.clientX &&
              s.clientX <= l.left + l.width;
          c || a.close();
        }),
        (o.querySelector(
          '.facets-container jolly-dropdown-collection'
        ).innerHTML = ''),
        o
          .querySelector('facet-remove a')
          .setAttribute('href', window.location.href);
      let i = o.querySelector('.facets-container .jc-filters--submit');
      if (i) {
        const s = document.createElement('div');
        (s.className = i.className),
          s.classList.add('jc-facets__close'),
          (s.innerHTML = i.innerHTML),
          i.parentNode.replaceChild(s, i);
      }
      (a.innerHTML = o.querySelector('.facets-container').innerHTML),
        this.appendChild(a),
        document
          .querySelector('.jc-filters-toggle')
          .addEventListener('click', () => {
            a.showModal();
          }),
        document.querySelectorAll('.jc-facets__close').forEach((s) => {
          s.addEventListener('click', () => {
            a.close();
          });
        });
    } catch (e) {
      console.error(e.message);
    }
  }
  async updateListProducts(e) {
    setTimeout(() => {
      let r = '';
      document
        .querySelectorAll(".mobile-facets__checkbox:checked[type='checkbox']")
        .forEach((n) => {
          r += n.name + '=' + n.value.replaceAll(' ', '+') + '&';
        }),
        this.updateFilters(r);
    }, 700);
  }
  async updateFilters(e = '') {
    try {
      let r = await fetch(
        window.Shopify.routes.root +
          'collections/' +
          this.dataset.collection +
          '?filter.v.availability=1&' +
          e
      );
      if (!r.ok) throw new Error(`Fetch failed with status: ${r.status}`);
      let n = await r.text();
      const o = new DOMParser(),
        a = o.parseFromString(n, 'text/html'),
        i = a.querySelector('#available-products-id').innerHTML;
      a.querySelectorAll("label[for^='Filter']").forEach((s) => {
        document.querySelector(`label[for='${s.getAttribute('for')}']`) &&
          document
            .querySelector(`label[for='${s.getAttribute('for')}']`)
            .setAttribute('class', s.getAttribute('class'));
      }),
        this.updateProductsVisibility(i);
    } catch (r) {
      console.error(r.message);
    }
  }
  updateProductsVisibility(e) {
    document.querySelectorAll('jolly-pack-card', (l) => {
      l.classList.remove('jc-hidden');
    });
    let r = document.querySelector('#original-products-id').innerHTML;
    r = r.substring(0, r.length - 1);
    let n = r.split(','),
      o = String(e);
    o = o.substring(0, o.length - 1);
    let a = o.split(',');
    function i(l, c) {
      return l.filter((d) => !c.includes(d));
    }
    const s = i(n, a);
    document.querySelectorAll('jolly-pack-card').forEach((l) => {
      l.classList.remove('jc-hidden'),
        s.includes(l.getAttribute('jolly-card-id')) &&
          l.classList.add('jc-hidden');
    }),
      document.querySelector('.js-loader').classList.add('jc-hidden');
  }
}
function I(t) {
  let e = 0;
  for (const r in q)
    if (t >= parseInt(r)) e = q[r];
    else break;
  return e;
}
customElements.define('jolly-pack-card', kt);
customElements.define('jolly-pack-details', Et);
customElements.define('jolly-add-to-pack', wt);
customElements.define('jolly-pack-modal', Lt, {
  extends: 'dialog',
});
customElements.define('jolly-pack-quantity-selector', jt);
customElements.define('jolly-pack-checkout', Tt);
customElements.define('jolly-pack-filters', Pt);
customElements.define('jolly-pack-progress', tt);
function et() {
  let t = document.querySelectorAll('.jc-delivery-swiper');
  for (let e = 0; e < t.length; e++)
    new g('#' + t[e].id, {
      modules: [L, w, D, T],
      effect: 'fade',
      loop: !0,
      pagination: {
        el: '#' + t[e].id + ' .swiper-pagination',
        clickable: !0,
      },
      fadeEffect: {
        crossFade: !0,
      },
      autoplay: {
        delay: 4e3,
      },
    });
}
function B() {
  new g('#upsalesSlider', {
    modules: [D, L],
    slidesPerView: 'auto',
    observer: !0,
    spaceBetween: 16,
    autoplay: {
      delay: 4e3,
    },
    navigation: {
      prevEl: '#upsalesSlider .swiper-button-prev',
      nextEl: '#upsalesSlider .swiper-button-next',
    },
  });
}
B();
et();
document.addEventListener('jc-cart:reload', (t) => {
  B(), et();
});
async function $(t, e, r) {
  return new Promise(function (n, o) {
    const a = 'id:' + e,
      i = e ? '&q=' + a : '',
      s = window.Shopify.routes.root + 'search/?sections=' + t + i;
    fetch(s).then(function (l) {
      l.json().then(function (c) {
        var d = Object.keys(c);
        return d.length > 0 ? n(c[d[0]]) : o();
      });
    });
  });
}
async function It(t, e, r) {
  const n = await $(t, e);
  let o = document.querySelector('jolly-modal-product');
  const a = document.getElementById('jolly-modal-product');
  a.innerHTML = n;
  const i = a.querySelector('[js-add-to-cart-btn]');
  r == !0 && i.classList.add('jc-upsales-button'),
    o.classList.remove('jc-translate-y-full'),
    o.classList.add('jc-translate-y-0');
}
customElements.get('jolly-product-card') ||
  customElements.define(
    'jolly-product-card',
    class extends HTMLElement {
      constructor() {
        super(),
          (this.elements = {
            addMobileCard: this.querySelectorAll('.jc-mobile-cart-item-add'),
            addBtn: this.querySelectorAll('[js-add-to-cart-btn]'),
          }),
          this.elements.addMobileCard.forEach((e) => {
            e.addEventListener('click', (r) => {
              r.preventDefault();
              let n = this.getAttribute('jolly-card-id'),
                o = this.querySelector('.jolly-card-section').dataset.section,
                a = !1;
              e.classList.contains('jc-mobile-upsale-item') && (a = !0),
                document
                  .getElementById('jc-modal-shadow')
                  .classList.remove('jc-hidden'),
                It(o, n, a);
            });
          });
      }
    }
  );
async function Mt(t, e, r) {
  var y, h, p, f, S, b;
  const n = await $(e),
    a = new DOMParser().parseFromString(n, 'text/html'),
    i = document.querySelector('#cart-drawer'),
    s = i.querySelector('cart-drawer-items'),
    l = i.querySelector('#cart_items_size'),
    c = i.querySelector('#CartDrawerTotals'),
    d = i.querySelector(`#CartDrawer-Item-${r} .price`),
    u = i.querySelector(`#CartDrawer-Item-${r} .price-old`);
  l.innerHTML.trim() !=
    ((y = a.querySelector('#cart_items_size')) == null
      ? void 0
      : y.innerHTML.trim()) &&
    (l.innerHTML =
      (h = a.querySelector('#cart_items_size')) == null ? void 0 : h.innerHTML),
    c.innerHTML.trim() !=
      a.querySelector('#CartDrawerTotals').innerHTML.trim() &&
      (c.innerHTML = a.querySelector('#CartDrawerTotals').innerHTML),
    t == !0
      ? (a.querySelector(`#CartDrawer-Item-${r} .price`) != null
          ? d &&
            d.innerHTML.trim() !=
              ((p = a.querySelector(`#CartDrawer-Item-${r} .price`)) == null
                ? void 0
                : p.innerHTML.trim()) &&
            (d.innerHTML =
              (f = a.querySelector(`#CartDrawer-Item-${r} .price`)) == null
                ? void 0
                : f.innerHTML)
          : d && (d.innerHTML = ''),
        a.querySelector(`#CartDrawer-Item-${r} .price-old`) != null
          ? u &&
            u.innerHTML.trim() !=
              ((S = a.querySelector(`#CartDrawer-Item-${r} .price-old`)) == null
                ? void 0
                : S.innerHTML.trim()) &&
            (u.innerHTML =
              (b = a.querySelector(`#CartDrawer-Item-${r} .price-old`)) == null
                ? void 0
                : b.innerHTML)
          : u && (u.innerHTML = ''))
      : a.querySelector('cart-drawer-items') != null
      ? s &&
        s.innerHTML.trim() !=
          a.querySelector('cart-drawer-items').innerHTML.trim() &&
        (s.innerHTML = a.querySelector('cart-drawer-items').innerHTML)
      : s && (s.innerHTML = ''),
    a.querySelector('#cart_items_size').dataset.items == 0 &&
      i.classList.add('is-empty'),
    document.dispatchEvent(new CustomEvent('jc-cart:reload')),
    document.dispatchEvent(new CustomEvent('cart:update'));
}
async function At(t) {
  if (t.items.length == 0) return;
  let e = 0;
  for (const o in t.items)
    t.items[o].properties.hasOwnProperty('_pack') &&
      t.items[o].properties._pack == 'true' &&
      ((e += t.items[o].quantity),
      document.dispatchEvent(new CustomEvent('cart:update')));
  const r = document.querySelector('jolly-pack-progress[cart]'),
    n = document.querySelector('jolly-pack-progress[pack-page]');
  r && r.setAttribute('qnt', e),
    n && n.setAttribute('qnt', e),
    document.dispatchEvent(new CustomEvent('cart:update'));
}
async function rt() {
  const t = document.getElementById('cart-icon-bubble').dataset.sectionId,
    e = await $(t),
    n = new DOMParser().parseFromString(e, 'text/html'),
    o = document.querySelector('#cart-icon-bubble');
  o.innerHTML = n.querySelector('#cart-icon-bubble').innerHTML;
}
async function at(t, e, r) {
  const n = window.Shopify.routes.root + 'cart/change.js',
    o = {
      line: e,
      quantity: r,
    },
    a = 'cart-drawer';
  try {
    const i = await fetch(n, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(o),
    });
    if (!i.ok) throw new Error(`HTTP error! Status: ${i.status}`);
    const s = await i.json();
    Mt(t, a, e), At(s), rt();
  } catch (i) {
    console.error('Error removing product from cart:', i);
  } finally {
    document.querySelectorAll('.loading-overlay').forEach((i) => {
      i.classList.add('jc-hidden');
    });
  }
}
class Ht extends HTMLElement {
  constructor() {
    super(),
      this.addEventListener('click', (e) => {
        e.preventDefault();
        let r = this.dataset.index,
          n = 0,
          o = !1;
        this.closest('.js-cart-item')
          .querySelector('.loading-overlay')
          .classList.remove('jc-hidden'),
          at(o, r, n);
      });
  }
}
customElements.define('cart-remove-button', Ht);
class xt extends HTMLElement {
  constructor() {
    super(),
      (this.elements = {
        btn: this.querySelector('[js-add-to-cart-btn]'),
      }),
      this.elements.btn.addEventListener('click', (e) => {
        e.preventDefault();
        let n = {
          items: [
            {
              id: this.elements.btn.dataset.id,
              quantity: 1,
            },
          ],
          sections: ['cart-drawer', 'cart-icon-bubble'],
        };
        const o = document.querySelector('cart-drawer').dataset.sectionId;
        (this.elements.btn.querySelector('.btn-label').style.opacity = 0),
          (this.elements.btn.querySelector('.btn-load').style.opacity = 1),
          fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(n),
          })
            .then(async (a) => {
              let i = await a.json();
              rt(),
                fetch(window.Shopify.routes.root + '?sections=' + o)
                  .then((l) => l.json())
                  .then((l) => {
                    let c = l[o];
                    const u = new DOMParser().parseFromString(c, 'text/html');
                    (document.querySelector('.drawer__inner').innerHTML =
                      u.querySelector('.drawer__inner').innerHTML),
                      document
                        .querySelector('cart-drawer')
                        .classList.remove('is-empty'),
                      document
                        .querySelector('cart-drawer')
                        .classList.add('active'),
                      document.dispatchEvent(new CustomEvent('jc-cart:reload')),
                      this.elements.btn.classList.contains(
                        'jc-upsales-button'
                      ) &&
                        document
                          .querySelectorAll('[id*="CartDrawer-Item"]')
                          .forEach((y) => {
                            let h = y.getAttribute('jolly-cart-item');
                            document
                              .querySelectorAll('[jolly-upsale-slide]')
                              .forEach((p) => {
                                p.classList.remove('!jc-hidden');
                              }),
                              document
                                .querySelectorAll(
                                  '[jolly-upsale-slide="' + h + '"]'
                                )
                                .forEach((p) => {
                                  p.classList.add('!jc-hidden');
                                });
                          });
                  });
              const s = this.elements.btn.querySelector('.btn-label').innerHTML;
              (this.elements.btn.querySelector('.btn-label').innerHTML =
                translations.products.productAdded),
                this.elements.btn.classList.add('with-success'),
                i.items.length == 0 &&
                  document
                    .querySelector('cart-drawer')
                    .classList.add('is-empty'),
                document
                  .querySelector('cart-drawer')
                  .classList.remove('is-empty'),
                document.querySelector('cart-drawer').classList.add('active'),
                this.elements.btn.classList.contains('jc-upsales-button') &&
                  document
                    .querySelectorAll('[id*="CartDrawer-Item"]')
                    .forEach((c) => {
                      let d = c.getAttribute('jolly-cart-item');
                      document
                        .querySelectorAll('[jolly-upsale-slide]')
                        .forEach((u) => {
                          u.classList.remove('!jc-hidden');
                        }),
                        document
                          .querySelectorAll('[jolly-upsale-slide="' + d + '"]')
                          .forEach((u) => {
                            u.classList.add('!jc-hidden');
                          });
                    }),
                B(),
                (this.elements.btn.querySelector(
                  '.btn-label'
                ).style.opacity = 1),
                (this.elements.btn.querySelector(
                  '.btn-load'
                ).style.opacity = 0),
                setTimeout(() => {
                  (this.elements.btn.querySelector('.btn-label').innerHTML = s),
                    this.elements.btn.classList.remove('with-success');
                }, 2e3);
            })
            .then(() => {})
            .catch((a) => {
              console.error('Error:', a);
            });
      });
  }
}
customElements.define('add-to-cart', xt);
class Ct extends HTMLElement {
  constructor() {
    super(),
      this.addEventListener(
        'keyup',
        (e) => e.code === 'Escape' && this.close()
      ),
      this.querySelector('#CartDrawer-Overlay').addEventListener(
        'click',
        this.close.bind(this)
      ),
      this.setHeaderCartIconAccessibility(),
      this.querySelector('.drawer__close').addEventListener('click', (e) => {
        this.close();
      });
  }
  setHeaderCartIconAccessibility() {
    document.querySelectorAll('.cart-icon-bubble-open').forEach((r) => {
      r.setAttribute('role', 'button'),
        r.setAttribute('aria-haspopup', 'dialog'),
        r.addEventListener('click', (n) => {
          n.preventDefault(), this.open(r);
        }),
        r.addEventListener('keydown', (n) => {
          n.code.toUpperCase() === 'SPACE' &&
            (n.preventDefault(), this.open(r));
        });
    });
  }
  open(e) {
    e && this.setActiveElement(e);
    const r = this.querySelector('[id^="Details-"] summary');
    r && !r.hasAttribute('role') && this.setSummaryAccessibility(r),
      setTimeout(() => {
        this.classList.add('animate', 'active');
      }),
      this.addEventListener(
        'transitionend',
        () => {
          this.classList.contains('is-empty')
            ? this.querySelector('.drawer__inner-empty')
            : document.getElementById('CartDrawer'),
            this.querySelector('cart-drawer') ||
              this.querySelector('.drawer__close');
        },
        {
          once: !0,
        }
      ),
      document.body.classList.add('overflow-hidden');
  }
  close() {
    this.classList.remove('active'),
      document.body.classList.remove('overflow-hidden');
  }
  setSummaryAccessibility(e) {
    e.setAttribute('role', 'button'),
      e.setAttribute('aria-expanded', 'false'),
      e.nextElementSibling.getAttribute('id') &&
        e.setAttribute('aria-controls', e.nextElementSibling.id),
      e.addEventListener('click', (r) => {
        r.currentTarget.setAttribute(
          'aria-expanded',
          !r.currentTarget.closest('details').hasAttribute('open')
        );
      }),
      e.parentElement.addEventListener('keyup', onKeyUpEscape);
  }
  setActiveElement(e) {
    this.activeElement = e;
  }
}
customElements.define('cart-drawer', Ct);
let k = {};
function Dt(t, e) {
  return (
    k[t] === void 0 && (k[t] = []),
    (k[t] = [...k[t], e]),
    function () {
      k[t] = k[t].filter((n) => n !== e);
    }
  );
}
class Ot extends HTMLElement {
  constructor() {
    super();
    A(this, 'quantityUpdateUnsubscriber');
    (this.input = this.querySelector('input')),
      (this.changeEvent = new Event('change', {
        bubbles: !0,
      })),
      (this.productId = this.dataset.productId),
      (this.removeBtn = this.querySelector('cart-remove-button')),
      this.input.addEventListener('change', this.onInputChange.bind(this)),
      this.querySelectorAll('button').forEach((r) =>
        r.addEventListener('click', this.onButtonClick.bind(this))
      );
  }
  connectedCallback() {
    this.validateQtyRules(),
      (this.quantityUpdateUnsubscriber = Dt(
        PUB_SUB_EVENTS.quantityUpdate,
        this.validateQtyRules.bind(this)
      ));
  }
  disconnectedCallback() {
    this.quantityUpdateUnsubscriber && this.quantityUpdateUnsubscriber();
  }
  onInputChange(r) {
    this.validateQtyRules();
  }
  onButtonClick(r) {
    r.preventDefault();
    const n = this.input.value;
    if (
      (r.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown(),
      n !== this.input.value)
    ) {
      this.input.dispatchEvent(this.changeEvent);
      let o = this.input.value,
        a = this.input.dataset.index,
        i = !0;
      this.closest('.js-cart-item')
        .querySelector('.loading-overlay')
        .classList.remove('jc-hidden'),
        at(i, a, o);
    } else return;
  }
  validateQtyRules() {
    const r = parseInt(this.input.value);
    if (this.input.min) {
      const n = parseInt(this.input.min),
        o = this.querySelector(".jc-quantity-btn[name='minus']");
      o.classList.toggle('disabled', r <= n),
        o.classList.toggle('!jc-hidden', r <= 1);
    }
    if (this.input.max) {
      const n = parseInt(this.input.max);
      this.querySelector(".jc-quantity-btn[name='plus']").classList.toggle(
        'disabled',
        r >= n
      );
    }
    r <= 1
      ? this.removeBtn.classList.remove('!jc-hidden')
      : this.removeBtn.classList.add('!jc-hidden');
  }
}
customElements.define('quantity-input', Ot);
class Bt extends HTMLElement {
  constructor() {
    var e;
    super(),
      (this.elements = {
        addToCartBtn: this.querySelector('.add-to-cart-btn'),
        productId: this.querySelector('[name="id"]').value,
        properties:
          (e = this.querySelector('[name="props"]')) == null ? void 0 : e.value,
      }),
      this.elements.addToCartBtn &&
        this.elements.addToCartBtn.addEventListener('click', (r) => {
          var i;
          r.preventDefault();
          let n =
              (this.querySelector('[name="id"]') &&
                this.querySelector('[name="id"]').value) ||
              this.elements.productId,
            o = this.elements.properties,
            a =
              ((i = this.querySelector('[name="quantity"]')) == null
                ? void 0
                : i.value) || 1;
          this.addToCart(n, a, o);
        });
  }
  addToCart(e, r, n) {
    let o = {
      items: [
        {
          id: e,
          quantity: r,
          properties: {
            _pack: n,
          },
        },
      ],
      sections: ['cart-drawer', 'cart-icon-bubble'],
    };
    console.log(o);
    const a = document.querySelector('cart-drawer').dataset.sectionId;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(o),
    })
      .then(async (i) => {
        await i.json(),
          fetch(
            window.Shopify.routes.root + 'search/?sections=cart-icon-bubble'
          )
            .then((s) => s.json())
            .then((s) => {
              const c = new DOMParser().parseFromString(
                  s['cart-icon-bubble'],
                  'text/html'
                ),
                d = document.querySelector('.cart-count-bubble');
              d.innerHTML = c.querySelector('.cart-count-bubble').innerHTML;
            }),
          fetch(window.Shopify.routes.root + '?sections=' + a)
            .then((s) => s.json())
            .then((s) => {
              let l = s[a];
              const d = new DOMParser().parseFromString(l, 'text/html');
              (document.querySelector('.drawer__inner').innerHTML =
                d.querySelector('.drawer__inner').innerHTML),
                document
                  .querySelector('cart-drawer')
                  .classList.remove('is-empty'),
                document.querySelector('cart-drawer').classList.add('active'),
                document.dispatchEvent(new CustomEvent('jc-cart:reload')),
                document.dispatchEvent(new CustomEvent('cart:update'));
            });
      })
      .catch((i) => console.error('Error adding to cart:', i));
  }
}
customElements.get('add-to-cart-btn') ||
  customElements.define('add-to-cart-btn', Bt);
document.querySelectorAll('.js-wrapper-dialog').forEach((t) => {
  const e = 'data-tooltip-button-id',
    r = 'data-tooltip-id',
    n = 'active',
    o = Array.from(t.querySelectorAll(`[${e}]`)),
    a = Array.from(t.querySelectorAll(`[${r}]`)),
    i = (s) =>
      a.forEach((l) => {
        s !== l && l.classList.remove(n);
      });
  window.addEventListener('click', (s) => {
    s.stopPropagation(), i();
  }),
    o.forEach((s) => {
      const l = s.getAttribute(e),
        c = a.filter((d) => d.getAttribute(r) === l)[0];
      s.addEventListener('click', (d) => {
        d.stopPropagation(), i(n), c.classList.toggle(n);
      });
    });
});
new g('.js-reassuranse-banner', {
  modules: [w],
  slidesPerView: 1.6,
  spaceBetween: 16,
  direction: 'horizontal',
  touch: !0,
  pagination: {
    el: '.swiper-pagination',
  },
  loopedSlides: !0,
  mousewheel: {
    forceToAxis: !0,
  },
  breakpoints: {
    650: {
      slidesPerView: 2,
    },
    875: {
      slidesPerView: 2.5,
    },
    1024: {
      slidesPerView: 4,
    },
  },
});
document.querySelectorAll('.js-reviews-swiper').forEach((t) => {
  new g('#' + t.id, {
    modules: [w, L],
    slidesPerView: 'auto',
    spaceBetween: 16,
    direction: 'horizontal',
    touch: !0,
    pagination: {
      el: '.js-swiper-pagination',
    },
    navigation: {
      prevEl: document.querySelector('#' + t.id + ' .swiper-button-prev'),
      nextEl: document.querySelector('#' + t.id + ' .swiper-button-next'),
    },
  });
});
const C = document.querySelector('[data-show-recover-password]');
nt();
window.addEventListener('hashchange', nt);
function nt() {
  C == null ||
    C.setAttribute(
      'data-show-recover-password',
      window.location.hash.replace('#', '') === 'recover'
    );
}
class $t extends HTMLElement {
  constructor() {
    super(),
      (this.elements = {
        variants: this.querySelectorAll('[js-variants-values]'),
        variantsJSON: this.querySelector('[data-product-variants-json]'),
        sectionId: 'ajax-jolly-product-info',
      }),
      this.init();
  }
  async updateProductInfo(e, r, n) {
    var o;
    try {
      const a = await fetch(
        window.Shopify.routes.root +
          'products/' +
          e +
          '?variant=' +
          r +
          '&section_id=' +
          n
      );
      if (!a.ok) throw new Error(`Failed to fetch product: ${a.statusText}`);
      const i = await a.text(),
        c =
          (o = new DOMParser()
            .parseFromString(i, 'text/html')
            .querySelector('.jc-product-card-controls')) == null
            ? void 0
            : o.innerHTML;
      this.closest('.jc-product-card-controls').innerHTML = c;
      let d = {
        items: [
          {
            id: r,
            quantity: 1,
          },
        ],
        sections: ['cart-drawer', 'cart-icon-bubble'],
      };
      const u = document.querySelector('cart-drawer').dataset.sectionId;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(d),
      })
        .then(async (m) => {
          let y = await m.json();
          fetch(
            window.Shopify.routes.root + 'search/?sections=cart-icon-bubble'
          )
            .then((h) => h.json())
            .then((h) => {
              const f = new DOMParser().parseFromString(
                  h['cart-icon-bubble'],
                  'text/html'
                ),
                S = document.querySelector('.cart-count-bubble');
              S.innerHTML = f.querySelector('.cart-count-bubble').innerHTML;
            }),
            fetch(window.Shopify.routes.root + '?sections=' + u)
              .then((h) => h.json())
              .then((h) => {
                let p = h[u];
                const S = new DOMParser().parseFromString(p, 'text/html');
                (document.querySelector('.drawer__inner').innerHTML =
                  S.querySelector('.drawer__inner').innerHTML),
                  document
                    .querySelector('cart-drawer')
                    .classList.remove('is-empty'),
                  document.querySelector('cart-drawer').classList.add('active'),
                  document.dispatchEvent(new CustomEvent('jc-cart:reload'));
              });
        })
        .catch((m) => console.error('Error adding to cart:', m));
    } catch (a) {
      console.error(`An error occurred: ${a}`);
    }
  }
  init() {
    this.elements.variants.forEach((e) => {
      e &&
        e.addEventListener('click', async () => {
          const r = JSON.parse(this.elements.variantsJSON.textContent),
            n = this.querySelectorAll('[js-variants-values]:checked');
          let o = [];
          n.forEach((c) => {
            o.push(c.value);
          });
          const a = r.filter((c) => o.includes(c.option1));
          r.filter((c) => c.options.join(',') === o.join(','))[0];
          const i = this.dataset.productHandle;
          let s = '';
          s = a[0].id;
          const l = this.elements.sectionId;
          await this.updateProductInfo(i, s, l);
        });
    });
  }
}
customElements.define('sizes-variant-picker', $t);
let X = 0;
function ot() {
  const t = document.querySelector('header').offsetHeight,
    e = document.querySelector('.js-faq-summary');
  X != t && e && ((e.style.top = t + 'px'), (X = t));
}
ot();
window.addEventListener('resize', ot);
new g('#announcementBarSwiper', {
  modules: [D, T],
  speed: 500,
  loop: !0,
  effect: 'fade',
  autoplay: {
    delay: 3e3,
  },
  autoplay: {
    delay: 3e3,
    disableOnInteraction: !1,
  },
  noSwiping: !0,
  noSwipingClass: 'swiper-slide',
});
document.querySelectorAll('.js-video-testimonials').forEach((t) => {
  new g('#' + t.id, {
    modules: [L],
    slidesPerView: 'auto',
    spaceBetween: 12,
    mousewheel: !1,
    navigation: {
      prevEl: document.querySelector('#' + t.id + ' .swiper-button-prev'),
      nextEl: document.querySelector('#' + t.id + ' .swiper-button-next'),
    },
  });
});
document.querySelectorAll('.js-search-products').forEach((t) => {
  new g('#' + t.id, {
    modules: [L],
    slidesPerView: 2.1,
    spaceBetween: 16,
    mousewheel: !1,
    breakpoints: {
      768: {
        slidesPerView: 2.1,
      },
      992: {
        slidesPerView: 3,
      },
      1280: {
        slidesPerView: 4,
      },
    },
  });
});
const Y = document.querySelectorAll('.jc-review-testimonial-swiper'),
  Ft = document.querySelectorAll('.jc-review-testimonial-swiper-thumbs');
for (let t = 0; t < Y.length; t++) {
  const e = new g('#' + Ft[t].id, {
      modules: [j],
      slidesPerView: 'auto',
      spaceBetween: 24,
      initialSlide: 1,
      centeredSlides: !0,
      slideToClickedSlide: !0,
    }),
    r = new g('#' + Y[t].id, {
      modules: [ut, j, T],
      noSwiping: !0,
      effect: 'fade',
      speed: 300,
      initialSlide: 1,
      noSwipingClass: 'swiper-slide',
    });
  (e.controller.control = r), (r.controller.control = e);
}
new g('.jc-products-swiper', {
  slidesPerView: 'auto',
  spaceBetween: 12,
  loop: !1,
});
